const openCloseModal = (state, action) => ({
  ...state,
  open: action.payload.open,
});

export default openCloseModal;
